import proj4 from 'proj4'

window.proj4 = window.proj4 || proj4

export default proj4
